import template from './admin-hotel-amenities.html';

const DIRECTIVE_NAME = AdminHotelAmenities.DIRECTIVE_NAME = 'ktAdminHotelAmenities';
export default function AdminHotelAmenities() {
    return {
        restrict: 'A',
        controller: AdminHotelAmenitiesController,
        controllerAs: 'adminHotelAmenitiesCtrl',
        template,
        bindToController: true,
        scope: {
            amenities: `=${DIRECTIVE_NAME}`,
        },
        link: function($scope, $elem, $attrs, adminHotelAmenitiesCtrl) {
            adminHotelAmenitiesCtrl.$onInit();
        },
    };
}

function AdminHotelAmenitiesController() {
    const vm = this;

    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-hotel-edit/admin-hotel-amenities/admin-hotel-amenities-component.js